import { render, staticRenderFns } from "./JourneyConnectionSettings.vue?vue&type=template&id=e4ad0596&scoped=true&"
import script from "./JourneyConnectionSettings.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionSettings.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/journey-connection-settings.scss?vue&type=style&index=0&id=e4ad0596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ad0596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ad0596')) {
      api.createRecord('e4ad0596', component.options)
    } else {
      api.reload('e4ad0596', component.options)
    }
    module.hot.accept("./JourneyConnectionSettings.vue?vue&type=template&id=e4ad0596&scoped=true&", function () {
      api.rerender('e4ad0596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/JourneyConnectionSettings.vue"
export default component.exports